import { usePostPortfolioLifeInsuranceMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioLifeInsuranceMutation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { LIFE_INSURANCE_FORM_DEFAULT_VALUES } from "web_myplann/Portfolio/Forms/LifeInsuranceForm/lifeInsuranceFormDefaults";
import { getLifeInsuranceFormSchema } from "web_myplann/Portfolio/Forms/LifeInsuranceForm/lifeInsuranceFormSchema";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreateLifeInsuranceForm = () => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPortfolioLifeInsuranceMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getLifeInsuranceFormSchema(t),
		defaultValues: LIFE_INSURANCE_FORM_DEFAULT_VALUES,
		mutate,
		successRoute: Routing.Portfolio.PortfolioAddLifeInsuranceSuccess.path(),
	});

	return { form, onSubmit, isPending };
};
